/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FarmTotal
 */
export interface FarmTotal {
  /**
   *
   * @type {string}
   * @memberof FarmTotal
   */
  address?: string
  /**
   *
   * @type {number}
   * @memberof FarmTotal
   */
  holderBonus?: number
}

export function FarmTotalFromJSON(json: any): FarmTotal {
  return FarmTotalFromJSONTyped(json, false)
}

export function FarmTotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): FarmTotal {
  if (json === undefined || json === null) {
    return json
  }
  return {
    address: !exists(json, 'address') ? undefined : json['address'],
    holderBonus: !exists(json, 'holderBonus') ? undefined : json['holderBonus'],
  }
}

export function FarmTotalToJSON(value?: FarmTotal | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    address: value.address,
    holderBonus: value.holderBonus,
  }
}
